function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_870",
  "data-name": "Group 870",
  transform: "translate(-813 -563.293)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_498",
  "data-name": "Rectangle 498",
  transform: "translate(813 567.043)",
  fill: "none",
  stroke: "#898989",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 10.956,
  height: 10.956,
  rx: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 9.956,
  height: 9.956,
  rx: 1.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_499",
  "data-name": "Rectangle 499",
  width: 3.652,
  height: 5.478,
  transform: "translate(816.652 566.435)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_869",
  "data-name": "Group 869",
  transform: "translate(816.592 564)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_10",
  "data-name": "Line 10",
  x1: 7.304,
  transform: "translate(1.826 0.033) rotate(90)",
  fill: "none",
  stroke: "#898989",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_11",
  "data-name": "Line 11",
  x2: 1.826,
  y2: 1.826,
  transform: "translate(3.785 1.826) rotate(180)",
  fill: "none",
  stroke: "#898989",
  strokeLinecap: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_12",
  "data-name": "Line 12",
  y1: 1.826,
  x2: 1.826,
  transform: "translate(1.826 1.826) rotate(180)",
  fill: "none",
  stroke: "#898989",
  strokeLinecap: "round",
  strokeWidth: 1
})));

var SvgIosShare = function SvgIosShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.956,
    height: 14.707,
    viewBox: "0 0 10.956 14.707",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIosShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ios_share.fddadb31.svg";
export { ForwardRef as ReactComponent };